import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ClipLoader from "react-spinners/ClipLoader";

import { useAddFMMutation } from "../../Data/services/foundMemberApi.js";
import { incentiveTierList } from "../../Helper/index.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import { Button, Input } from "../CustomComponents/index.js";
import ModalContainer from "../ModalContainer/index.js";
import cssStyles from "./styles/editModal.module.scss";

const EditFMModal = ({ handleEditModalClose, editData, refetch }) => {
  const [rowId, setRowId] = useState("");
  const [email, setEmail] = useState();
  // const [ctaUrl, setCtaUrl] = useState();
  // const [description, setDescription] = useState("");
  // const [imageUrl, setImageUrl] = useState("");
  // const [imageFile, setImageFile] = useState("");
  // const [imagePreview, setImagePreview] = useState("");
  const [sending, setSending] = useState(false);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      console.log(editData);
      setRowId(editData.id);
      setEmail(editData.email);
      // setImageUrl(editData.image_url);
      // setDescription(editData.description || "");
      // setCtaUrl(editData.cta_link || "");
      // setImagePreview(editData.image_url || "");
    }
  }, [editData, mounted]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const [selectedType, setSelectedType] = useState(incentiveTierList[0].value);

  const [addFoundingMember, { isLoading: adding }] = useAddFMMutation();
  // const [updateAdvertisement, { isLoading: updating }] = useUpdateEAMutation();

  const handleSubmit = async () => {
    console.log(rowId);
    // console.log(title);
    // console.log(imageUrl);

    setSending(true);
    try {
      // let imageName;
      // if (imageFile) {
      //   imageName = await handleImageUpload();
      // }

      if (!email) {
        Toast("Please fill all the fields", "error");
        setSending(false);
        return;
      }

      const data = {
        email: email,
      };

      let response;
      if (editData) {
        // response = await updateAdvertisement({ data, id: rowId }).unwrap();
      } else {
        response = await addFoundingMember(data).unwrap();
      }

      console.log(response);

      if (response.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.message);
        handleEditModalClose();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0">
              {editData
                ? "Edit Founding Member"
                : "Add Founding Member"}
            </p>
            <span className="bg-primary-hover d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="email"
                  placeholder="email"
                  value={email}
                  onChange={handleEmailChange}
                />
              </Col>
            </Row>

            {/* <Row>
              <Col md={12}>
                <SelectFieldComponent
                  classes={`m-0 py-2 border-2 pointer hover-border `}
                  firstOption={
                    incentiveTierList.find((item) => item.value === selectedType).label
                  }
                  optionsList={incentiveTierList}
                  onSelectChange={(value) => setSelectedType(value)}
                />
              </Col>
            </Row> */}

            <Row>
              <Col md={12}>
                <Button
                  classes={`mt-3 mb-2 ${sending || !email ? "bg-dark-subtle" : "shadow"
                    } `}
                  text={
                    sending ? (
                      <ClipLoader color="#01ffff" size="22" />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  disabled={sending || !email}
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditFMModal;
